/**
 * @file Vertical Tabs.
 */

import modulo from 'just-modulo';

/**
 * Vertical Tabs component.
 */
const vVerticalTabs = () => {
	const verticalTabs = document.querySelector('.v-vertical-tabs');

	if (!verticalTabs) {
		return;
	}

	const tabs = verticalTabs.querySelectorAll('.v-vertical-tabs__link');

	/**
	 * Switch tab.
	 *
	 * @param {Element} tab - The tab to switch to.
	 */
	const switchTab = (tab) => {
		[...tabs].forEach((t) => { t.setAttribute('aria-selected', 'false'); t.setAttribute('tabindex', '-1'); });
		tab.setAttribute('aria-selected', 'true');
		tab.removeAttribute('tabindex');
		tab.focus();

		const switchEvent = new CustomEvent('v-tab-switch', { detail: { tab } });
		document.dispatchEvent(switchEvent);
	};

	[...tabs].forEach((tab) => {
		tab.addEventListener('click', () => {
			switchTab(tab);
		});

		tab.addEventListener('keydown', (e) => {
			let dir = null;
			if (e.which === 38) {
				e.preventDefault();
				dir = 'left';
			} else if (e.which === 40) {
				e.preventDefault();
				dir = 'right';
			}

			if (dir) {
				const currentTabIndex = [...tabs].indexOf(tab);
				const newTabIndex = modulo(currentTabIndex + (dir === 'left' ? -1 : 1), tabs.length);
				const newTab = [...tabs][newTabIndex];
				switchTab(newTab);
			}
		});
	});
};

export default vVerticalTabs;
